


















import { Component, Vue, Watch } from "vue-property-decorator";
import { startOfMonth, endOfMonth, parseISO, addMonths, format } from "date-fns";

import EspressoAux from "@/components/Espresso/EspressoAux.vue"
import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import CreationCard from "@/layouts/DashboardLayoutComponents/CreationCard.vue";
import FormField from "@/layouts/DashboardLayoutComponents/FormField.vue";

import accountPayableModel from "@/models/accountPayable.model";

@Component({
	components: {
		PaginatedSearch,
		CreationCard,
		FormField,
	},
})
export default class AccountPayable extends Vue {
	entityModel: any;

	filterSchema: any[] = [
		{ name: "Data início", key: "startDate", kind: "date" },
		{ name: "Data fim", key: "endDate", kind: "date" },
	];
	filterEntity: any = {
		startDate: startOfMonth(new Date()).toISOString(),
		endDate: endOfMonth(new Date()).toISOString(),
	};

	accountPayableCreationFields = [
		{ key: "name", class: "md-size-25" },
		{ key: "expirationDate", class: "md-size-15" },
		{ key: "baseAmount", class: "md-size-15" },
		{ key: "paymentDate", class: "md-size-15" },
		{ key: "paymentAmount", class: "md-size-15" },
		{ key: "interestPenaltyAmount", class: "md-size-15" },
	];

	searchActions = [
		{ name: 'Excluir', icon: 'delete', color: '#FF5C5C', action: this.deleteAccount },
	];

	csvModel = `\uFEFFDespesa;Data de vencimento;Valor;Data do pagamento;Valor a pagar;Juros/multa
Conta de luz;18/08/2020;200;;200;0
Conta de gás;25/08/2020;160,65;;160,65;0
Conta de telefone;30/08/2020;500,38;;500,38;0`;

	constructor() {
		super();
		this.entityModel = accountPayableModel;
	}

	get searchFilter() {
		return {
			expirationDate: { $gte: this.filterEntity.startDate, $lte: this.filterEntity.endDate },
		};
	}

	async deleteAccount(account: any) {
		if (!(await EspressoAux.showConfirmationModal('Confirma a exclusão?')).value) {
			return;
		}
		try {
			await accountPayableModel.delete(account.id);
			this.$toasted.success('Conta excluída');
			(this.$refs.accountsSearch as any).refresh();
		} catch (error) {
			this.$toasted.error(error.friendlyMessage || 'Erro ao excluir. Tente novamente.');
			console.error(error);
		}
	}

	// Accounts copy
	isCopying = false;
	selectedAccounts: any[] = [];
	selectionHandler(accounts: any) {
		this.selectedAccounts = accounts;
	}
	async copyToNextMonth() {
		this.isCopying = true;
		for (const account of this.selectedAccounts) {
			try {
				const nextExpirationDate = addMonths(parseISO(account.expirationDate), 1);
				const accountCopy = { ...account, expirationDate: nextExpirationDate.toISOString(), paymentDate: null, attachmentUrl: null, id: null };
				await accountPayableModel.create(accountCopy);
				this.$toasted.success(`Conta ${account.name} copiada para o dia ${format(nextExpirationDate, 'dd/MM/yyyy')}`)
			} catch (error) {
				console.error(error);
				this.$toasted.error(`Não foi possível copiar a conta ${account.name}`);
			}
		}
		this.isCopying = false;
		(this.$refs.accountsSearch as any).refresh();
	}
}
